import { render, staticRenderFns } from "./ReadOnlyBanner.vue?vue&type=template&id=a2b96fd4&scoped=true&"
import script from "./ReadOnlyBanner.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyBanner.vue?vue&type=style&index=0&id=a2b96fd4&lang=scss&scoped=true&"
import style1 from "./ReadOnlyBanner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b96fd4",
  null
  
)

export default component.exports